// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const INITIALIZE_DATASET_STEP_SHAPES = [
  {
    stepType: PipelineStepType.INITIALIZE_DATASET,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      Dataset: {
        systemName: 'Dataset',
        displayName: 'Dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: null
  },
  {
    stepType: PipelineStepType.INITIALIZE_DATASET,
    isDeprecated: false,
    version: 1,
    inputDataShapes: {},
    outputDataShapes: {
      Dataset: {
        systemName: 'Dataset',
        displayName: 'Dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      dashboardId: {
        kind: 'domain',
        required: true,
        types: [
          'SQL_DASHBOARD'
        ]
      },
      blockId: {
        kind: 'domain',
        required: true,
        types: [
          'SQL_DASHBOARD_BLOCK'
        ]
      },
      dataFrameName: {
        kind: 'string',
        required: true
      },
      parameterizedSQLQuery: {
        kind: 'string',
        required: true
      },
      parameters: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            config: {
              kind: 'shape',
              required: true,
              fields: {
                isMulti: {
                  kind: 'boolean',
                  required: false
                },
                systemName: {
                  kind: 'string',
                  required: true
                },
                type: {
                  kind: 'enum',
                  required: true,
                  choices: [
                    'BIOENTITY_LINK',
                    'DATE',
                    'ENTRY_LINK',
                    'FOLDER_LINK',
                    'NUMBER',
                    'PROCESS_LINK',
                    'PROCESS_TASK_LINK',
                    'PROJECT_LINK',
                    'SELECTOR',
                    'STORABLE_LINK',
                    'STRING',
                    'STUDY_LINK',
                    'TEAM_LINK',
                    'USER_LINK'
                  ]
                },
                id: {
                  kind: 'string',
                  required: true
                },
                schemaFieldSelectorId: {
                  kind: 'domain',
                  required: false,
                  types: [
                    'DROPDOWN'
                  ]
                },
                storableSchemaId: {
                  kind: 'domain',
                  required: false,
                  types: [
                    'BOX_SCHEMA',
                    'CONTAINER_SCHEMA',
                    'LOCATION_SCHEMA',
                    'PLATE_SCHEMA'
                  ]
                },
                studySchemaId: {
                  kind: 'domain',
                  required: false,
                  types: [
                    'STUDY_SCHEMA'
                  ]
                },
                processTaskSchemaId: {
                  kind: 'domain',
                  required: false,
                  types: [
                    'WORKFLOW_TASK_SCHEMA'
                  ]
                },
                tagSchemaId: {
                  kind: 'domain',
                  required: false,
                  types: [
                    'ENTITY_SCHEMA'
                  ]
                }
              }
            },
            valueJson: {
              kind: 'anything',
              required: true
            }
          }
        }
      }
    }
  },
  {
    stepType: PipelineStepType.INITIALIZE_DATASET,
    isDeprecated: false,
    version: 2,
    inputDataShapes: {},
    outputDataShapes: {
      Dataset: {
        systemName: 'Dataset',
        displayName: 'Dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      dashboardId: {
        kind: 'domain',
        required: true,
        types: [
          'SQL_DASHBOARD'
        ]
      },
      blockId: {
        kind: 'domain',
        required: true,
        types: [
          'SQL_DASHBOARD_BLOCK'
        ]
      },
      dataFrameName: {
        kind: 'string',
        required: true
      },
      parameterizedSQLQuery: {
        kind: 'string',
        required: true
      },
      parameters: {
        kind: 'array',
        required: true,
        elementSpec: {
          kind: 'shape',
          required: true,
          fields: {
            config: {
              kind: 'shape',
              required: true,
              fields: {
                isMulti: {
                  kind: 'boolean',
                  required: false
                },
                systemName: {
                  kind: 'string',
                  required: true
                },
                type: {
                  kind: 'enum',
                  required: true,
                  choices: [
                    'BIOENTITY_LINK',
                    'DATE',
                    'ENTRY_LINK',
                    'FOLDER_LINK',
                    'NUMBER',
                    'PROCESS_LINK',
                    'PROCESS_TASK_LINK',
                    'PROJECT_LINK',
                    'SELECTOR',
                    'STORABLE_LINK',
                    'STRING',
                    'STUDY_LINK',
                    'TEAM_LINK',
                    'USER_LINK'
                  ]
                },
                id: {
                  kind: 'string',
                  required: true
                },
                schemaFieldSelectorId: {
                  kind: 'domain',
                  required: false,
                  types: [
                    'DROPDOWN'
                  ]
                },
                storableSchemaId: {
                  kind: 'domain',
                  required: false,
                  types: [
                    'BOX_SCHEMA',
                    'CONTAINER_SCHEMA',
                    'LOCATION_SCHEMA',
                    'PLATE_SCHEMA'
                  ]
                },
                studySchemaId: {
                  kind: 'domain',
                  required: false,
                  types: [
                    'STUDY_SCHEMA'
                  ]
                },
                processTaskSchemaId: {
                  kind: 'domain',
                  required: false,
                  types: [
                    'WORKFLOW_TASK_SCHEMA'
                  ]
                },
                tagSchemaId: {
                  kind: 'domain',
                  required: false,
                  types: [
                    'ENTITY_SCHEMA'
                  ]
                }
              }
            },
            valueJson: {
              kind: 'anything',
              required: true
            }
          }
        }
      },
      dashboardName: {
        kind: 'string',
        required: true
      },
      blockName: {
        kind: 'string',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
